module.exports = __webpack_public_path__ + "static/img/home7.b9245f9f.png";